// 所有的请求都放在该目录
import instance from "../utils/request";
//首页所有请求
//1. 获取首页数据
//1.1 获取轮播图列表
export function getindexImgs() {
    return instance.get('/indexImgs')
}
//1.2获取商品标题分组列表
export function getProdTagList(params) {
    return instance({
        url: '/prod/tag/prodTagList',
        method: 'get',
        params
    })
}
//1.3获取标题商品
export function getprodListByTagId(params) {
    return instance({
        url: '/prod/prodListByTagId', 
        method: 'get',
        params
    })
}
//1.4获取轮播标题列表
export function getcategoryInfo(params) {
    return instance({
        url: '/category/categoryInfo',
        method: 'get',
        params
    })
}


//首页橱窗商品处理
export function getShowWindow() {
    return instance({
        url: '/api/showWindow/getShowWindow?type=1',
        method: 'get'
    })
}



//]专题页 Topic
//专题请求 
export function getTopicList(params) {
    return instance({
        url: '/topic/list',
        method: 'get',
        params
    })
}


//6. 分类页 Category
// 全部分类数据接口
export function GetChannelDataApi(params) {
    return instance({
        url: '/category/categoryInfo',
        method: 'get',
        params
    })
}
// 获取当前分类数据
export function GetFenleiDataApi(params) {
    return instance({
        url: '/search/searchProdPage',
        method: 'get',
        params
    })
}





//我的页面 User
//登陆
export function GoLogin(params) {
    return instance({
        url: '/auth/loginByWeb',
        method: 'post',
        data: params
    })
}



//订单支付
export function getSubmit(orderShopParam) {
    return instance({
        url: '/p/order/submit',
        method: 'post',
        data: orderShopParam
    })
}



// 搜索页
// 根据关键字搜索接口
export function GetSearchData(params) {
    return instance.get('/search/searchProdPage', {
        params
    })
}

// 详情页
//根据id查询对应数据接口
export function getDetailData(params) {
    return instance.get('/prod/prodInfo', {
        params
    })
}
//详情页根据id评论数据列表获取
export function getProdCommData(params) {
    return instance.get('/prod/prodCommData', {
        params
    })
}
//详情页根据id获取评论内容 
export function getProdCommPageByProd(params) {
    return instance.get('/prod/prodCommPageByProd', {
        params
    })
}
//详情页相关产品
export function GetGoodsRelatedData(params) {
    return instance({
        url: '/goods/related',
        method: 'get',
        params
    })
}



// 2.搜索页 SearchPopup
// 历史记录列表和热门搜索列表
export function GetPopupData(params) {
    return instance({
        url: '/search/hotSearchByShopId?number=10&shopId=1&sort=1',
        method: 'get'
    })
}

//删除历史记录
export function Clearhistory(params) {
    return instance({
        url: '/search/clearhistory',
        method: 'post',
        data: params
    })
}





//4.分类数据获取 Channel
export function GetCateGoryData(params) {
    return instance({
        url: '/goods/category',
        method: 'get',
        params
    })
}
// 分类页面商品列表请求
export function GetCateGoryList(params) {
    return instance({
        url: '/goods/list',
        method: 'get',
        params
    })
}


// 获取品牌详情数据列表请求
export function GetBrandList(params) {
    return instance({
        url: '/brand/detail',
        method: 'get',
        params
    })
}


// 获取分页品牌详情中的产品列表
export function GetBrandListData(params) {
    return instance({
        url: '/goods/list',
        method: 'get',
        params
    })
}


//购物车页 Cart
// 购物车列表
export function GetCartData(params) {
    return instance({
        url: '/p/shopCart/info',
        method: 'post',
        data:params
    })
}
// 加入购物车
export function AddToCart(params) {
    return instance.post('/p/shopCart/changeItem', params)
}

// 获取购物车产品数量
export function GetCartCountData() {
    return instance({
        url: '/p/shopCart/prodCount?attribute=1',
        method: 'get',
    })
}


// 加入购物车
export function UpdateCartData(params) {
    return instance({
        url: '/p/shopCart/changeItem',
        method: 'post',
        data: params
    })
}



// 删除购物车商品
export function DeleteCartData2(params) {
    return instance({
        url: '/p/shopCart/deleteItem',
        method: 'DELETE',
        data: params
    })
}

// 切换购物车商品选中状态功能接口（含全选
export function ToggleCartCheckedData(datas) {
    return instance({
        url: '/p/shopCart/totalPay',
        method: 'post',
        data:datas
    })
}



//获取订单商品详情
export function getConfirm(params) {
    return instance({
        url: '/p/order/confirm',
        method: 'post',
        data: params
    })
}


//获取当前用户信息
export function GetUserInfo() {
    return instance({
        url: '/p/user/userInfo',
        method: 'get'
    })
}


//保存当前用户快递地址
export function getAddAddr(params) {
    return instance({
        url: '/p/address/addAddr',
        method: 'post',
        data: params
    })
}

//获取当前用户地址id的详细地址
export function GetaddrInfo(params) {
    return instance({
        url: `/p/address/addrInfo/${params}`,
        method: 'get',
    })
}


//获取验证码
export function GetsmsregistOrLogin(params) {
    return instance({
        url: '/sms/registOrLogin',
        method: 'get',
        params
    })
}



//验证码登陆
export function GetregistOrLogin(params) {
    return instance({
        url: '/user/registerOrLogin',
        method: 'put',
        data: params
    })
}
//账户密码登陆 - 机关事务单点登录
export function GetLoginByPassword(params) {
    return instance({
        url: '/user/registerOrBindUser-jgsw',
        method: 'get',
        params
    })
}



//获取收货地址
export function Getaddress() {
    return instance({
        url: `/p/address/list?attribute=1`,
        method: 'get'
    })
}


 //是否能配送
export function GetRegionBuyLimit(data) {
    return instance({
        url: `/p/order/regionBuyLimit`,
        method: 'post',
        data
    })
}

//获取openid
export function getOpenids(code) {
    return instance({
        url: `/getOpenid?code=${code}`,
        method: 'get'
    })
}

  //微信支付
  export const WXPay = (data) => {
    return instance({
      url: "/p/h5/order/pay",
      method: "post",
      data,
    });
  };
  
//获取订单中心列表
export function GetmyOrder(data) {
    console.log(data);
    return instance({
        url: `/p/myOrder/myOrder?current=${data.current}&size=${data.size}&status=${data.status}`,
        method: 'get',
    })
}


//获取订单物流详情
export function GetorderDetail(data) {
    console.log(data);
    return instance({
        url: `/p/myOrder/orderDetail?orderNumber=${data}`,
        method: 'get',
    })
}

//获取订单快递信息
export function GetmyDelivery(data) {
    return instance({
        url: `/p/myDelivery/orderInfo/${data}`,
        method: 'get',
    })
}

//获取用户订单数字
export function GetcenterInfo() {
    return instance({
        url: `/p/user/centerInfo`,
        method: 'get'
    })
}

//获取用户退款或售后状态
export function GetorderRefund(id) {
    return instance({
        url: `/p/orderRefund/list?current=${id}&size=20&startTime=&endTime=`,
        method: 'get'
    })
}
 /**
   * 获取退款申请详情
   */
export function GetorderRefundinfo(id) {
    return instance({
        url: `/p/orderRefund/info?refundSn=${id}`,
        method: 'get'
    })
}
  /**
   * 撤销退货退款申请
   */
export function GetorderRefundcancel(refundSn) {
    return instance({
        url: `/p/orderRefund/cancel`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data:refundSn
    })
}
  /**
   * 更改默认地址
   */
   export function GetorderdefaultAddr(id) {
    return instance({
        url: `/p/address/defaultAddr/${id}`,
        method: 'PUT',
        data:{
            addrId:id,
            attribute:1
        }
    })
}

//微信支付
export function getPay(params) {
    return instance({
        url: '/p/order/pay',
        method: 'post',
        data: params
    })
}

//微信支付1
export function getpayBalance(params) {
    return instance({
        url: '/p/order/payBalance',
        method: 'post',
        data: params
    })
}
  //商品退款
  export const apply = (data) => {
    return instance({
      url: '/p/orderRefund/apply',
      method: "post",
      data
    });
  };

  //查询购物车数量
  export const upload = (data) => {
    return instance({
      url: `/p/file/upload`,
      method: "post",
      data
    });
  };
    //查询订单列表
    export const orderDetail = (orderNumber) => {
        return instance({
          url: `/p/myOrder/orderDetail?orderNumber=${orderNumber}`,
          method: "get",
        });
      };

      //我的页面 User
//登陆
export function Getexchange(params) {
    return instance({
        url: '/p/giftcard/giftCard/exchange',
        method: 'post',
        data: params
    })
}


//收货地址
export function GetUpdateAddrOrder(params) {
    return instance({
        url: '/p/address/updateAddrOrder',
        method: 'post',
        data: params
    })
}


// 获取物流公司列表
export function getDeliveryList() {
  return instance({
    url: '/p/delivery/list',
    method: 'get'
  })
}


// 提交物流信息
export function submitExpress(data) {
  return instance({
    url: '/p/orderRefund/submitExpress',
    method: 'post',
    data
  })
}